import * as React from 'react';
import { translate } from 'react-i18next';
import * as c from 'models/constants';
import renderIcon from 'helpers/renderIcon';
require('./style.css');

interface IProps {
	/* functions props */
	sliderCallback: (ratio: number) => void;
	min?: number;
	max?: number;
	initialValue?: number;
	step?: number;
}

interface IState {
	value: number;
	min: number;
	max: number;
	step: number;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class Slider extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.handleButtonClick = this.handleButtonClick.bind(this);

		this.state = {
			value: props.initialValue ? props.initialValue : 0,
			min: props.min ? props.min : 0,
			max: props.max ? props.max : 1,
			step: props.step ? props.step : 0.1,
		};
	}

	public componentDidUpdate(prevProps: IProps) {
		if (prevProps.min !== this.props.min) {
			this.setState({ min: this.props.min });
		}
		if (prevProps.step !== this.props.step) {
			this.setState({ step: this.props.step });
		}
		if (prevProps.max !== this.props.max) {
			this.setState({ max: this.props.max });
		}
		if (prevProps.initialValue !== this.props.initialValue) {
			this.setState({ value: this.props.initialValue });
		}
	}

	private handleChange(event: any) {
		if (Number(event.target.value) < this.state.value) {
			this.setState({ value: Math.round((this.state.value - this.state.step + 0.00001) * 10) / 10 });
			this.props.sliderCallback(-this.state.step);
		} else {
			this.setState({ value: Math.round((this.state.value + this.state.step + 0.00001) * 10) / 10 });
			this.props.sliderCallback(this.state.step);
		}
	}

	private handleButtonClick(_, button: string) {
		if (button === '+') {
			if (this.state.value + this.state.step > this.state.max) {
				return;
			}
			this.setState({ value: Math.round((this.state.value + this.state.step + 0.00001) * 10) / 10 });
			this.props.sliderCallback(this.state.step);
		} else if (button === '-') {
			if (this.state.value - this.state.step < this.state.min) {
				return;
			}
			this.setState({ value: Math.round((this.state.value - this.state.step + 0.00001) * 10) / 10 });
			this.props.sliderCallback(-this.state.step);
		}
	}

	public render() {
		const { min, max, value, step } = this.state;

		return (
			<div className="sliderHolderWrapper d-flex justify-content-center align-items-center">
				{renderIcon('reduce', 32, 32, '', () => this.handleButtonClick({}, '-'))}
				<div className="seeker d-flex align-items-center">
					<input
						type="range"
						min={min}
						max={max}
						step={step}
						value={value}
						className="slider"
						id="zoomRange"
						onChange={this.handleChange}
					/>
				</div>
				{renderIcon('enlarge', 32, 32, '', () => this.handleButtonClick({}, '+'))}
			</div>
		);
	}
}
export { Slider };
